
export class SubscriptionModel {
    public static VendorSubscriptionType = ["CSP", "ADM", "ADY", "KASP", "WGS", "AMP", "VDC"];
    public static SubscriptionSalesType = ["MR", "AO", "AY", "IN"];
    public static CSPPerpetuals = ["85PS", "85SS", "85RI"];
}

export interface SHBaseResponse {
    hasError?: boolean;
    errorMessage?: string;
    hasWarning?: boolean;
    warnings?: string[];
}
